import React from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";

import Button from "@mui/material/Button";
import Check from "@mui/icons-material/Check";

import { showFormDialog } from "../../context/dialogSlice";
import { showNotification } from "../../../../features/core/slices/notification.slice";
import {
  parseKeyList,
  validateAddressFields,
} from "../../services/form.service";

function VerifyAddressBtn(props) {
  const {
    fieldProps,
    getValues,
    datagridFormState,
    trigger,
    getFieldState,
    disabled,
  } = props;
  const dispatch = useDispatch();
  const { tags, label, properties } = fieldProps;
  // tags sent to the validate api even when empty, so the service can return a value for them
  const alwaysIncludedTags = parseKeyList(properties?.alwaysIncludeTags).filter(
    (key) => tags?.includes(key)
  );

  const onBtnClick = () => {
    if (tags && tags.length) {
      tags.forEach((item) => trigger(item));
      setTimeout(() => {
        const errors = tags.reduce((errorMap, key) => {
          const { error } = getFieldState(key);
          if (error) return { ...errorMap, [key]: error };
          return errorMap;
        }, {});
        const errorMsg = validateAddressFields({
          tags,
          errors,
          btnType: "verify",
        });
        if (errorMsg)
          dispatch(
            showNotification({ type: "warning", msg: errorMsg, show: true })
          );
        else {
          const userEnteredAddress = tags
            .filter((key) => getValues(key) || alwaysIncludedTags.includes(key))
            .map((key) => ({ key, value: getValues(key) || "" }));
          const payload = {
            show: true,
            fieldProps,
            userEnteredAddress,
            datagridKey: datagridFormState && datagridFormState.datagridKey,
            recordId: datagridFormState && datagridFormState.record?.id,
          };
          dispatch(showFormDialog(payload));
        }
      }, 5);
    }
  };

  return (
    <Button
      variant="contained"
      onClick={onBtnClick}
      startIcon={<Check />}
      disabled={disabled}
    >
      {label}
    </Button>
  );
}
VerifyAddressBtn.propTypes = {
  fieldProps: PropTypes.shape({
    label: PropTypes.string.isRequired,
    tags: PropTypes.arrayOf(PropTypes.string),
    properties: PropTypes.shape({
      alwaysIncludeTags: PropTypes.string,
    }),
  }).isRequired,
  getValues: PropTypes.func.isRequired,
  getFieldState: PropTypes.func.isRequired,
  datagridFormState: PropTypes.shape({
    datagridKey: PropTypes.string.isRequired,
    record: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }),
  trigger: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};
VerifyAddressBtn.defaultProps = {
  datagridFormState: undefined,
};
export default VerifyAddressBtn;
